/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $NavigationSubItem = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        icon: {
    type: 'string',
    isRequired: true,
},
        label: {
    type: 'string',
    isRequired: true,
},
        rootPath: {
    type: 'string',
    isRequired: true,
},
        primaryNotice: {
    type: 'string',
},
        secondaryNotice: {
    type: 'string',
},
        if: {
    type: 'boolean',
    isRequired: true,
},
        noticeColor: {
    type: 'string',
},
        noticeColorSecondary: {
    type: 'string',
},
        enabled: {
    type: 'boolean',
    isRequired: true,
},
    },
};